import React from 'react';

import { classnames, padding, required } from '@lumapps/classnames';
import { useFormField } from '@lumapps/lumx-forms/hooks/useFormField';
import { useId } from '@lumapps/lumx-hooks/hooks/useId';
import { Chip, ChipGroup, FlexBox, InputHelper, Text, Typography } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { AI_REASON_TYPES, FEEDBACK_REASONS } from '../../constants';
import { AI } from '../../keys';

export const AiFeedbackReasonOptions = () => {
    const { translateKey } = useTranslate();
    const { field, fieldState } = useFormField({
        name: 'reason',
        label: '',
        isRequired: true,
    });
    const errorId = useId();
    const groupId = useId();

    return (
        <FlexBox orientation="vertical" gap="medium" className={padding('top')}>
            <Text
                typography={Typography.body1}
                as="p"
                className={classnames({
                    [required()]: true,
                })}
            >
                {translateKey(AI.HOW_DESCRIBE_ANSWER)}
            </Text>
            <ChipGroup aria-labelledby={groupId} role="group">
                {Object.values(AI_REASON_TYPES).map((value, index) => {
                    const isSelected = field.value === value;
                    /**
                     * The only button that should receive the field's ref is the one that should
                     * be focused if an error is raised on this field.
                     * In this case, it should be the selected button first and, if none is selected,
                     * the first button of the list.
                     */
                    const shouldHaveRef = field.value ? isSelected : index === 0;

                    return (
                        <Chip
                            aria-describedby={fieldState.error ? errorId : undefined}
                            ref={shouldHaveRef ? field.ref : undefined}
                            key={value}
                            isSelected={isSelected}
                            onClick={() => field.onChange(value)}
                        >
                            {translateKey(FEEDBACK_REASONS[value])}
                        </Chip>
                    );
                })}
            </ChipGroup>
            {fieldState.error && (
                <InputHelper id={errorId} kind="error">
                    {translateKey(GLOBAL.SELECT_REASON_LISTED)}
                </InputHelper>
            )}
        </FlexBox>
    );
};
